import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const MODULOS_CONST = 'system';
export const systemApi = `${baseUrl}/${MODULOS_CONST}`;

export const saveSystemService = async (id, data) => {
  const res = await axios.patch(`${systemApi}/${id}`, data, {
    headers: token({}),
  });
  return res;
};

export const oneSystemService = async () => {
  const res = await axios.post(
    `${systemApi}/info`,
    {
      key: 'todossomosunalacritas',
    },
    {
      headers: token({}),
    },
  );
  return res;
};
